module.exports = __webpack_public_path__ + "img/lose_lottery4_mall.fd8185fd.png";